'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _dec2, _dec3, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ClientSideComponent = require('core/ClientSideComponent');

var _ClientSideComponent2 = _interopRequireDefault(_ClientSideComponent);

var _reactRedux = require('react-redux');

var _reduxForm = require('redux-form');

var _reactI18next = require('react-i18next');

var _components = require('components');

var _auth = require('redux/modules/auth');

var authActions = _interopRequireWildcard(_auth);

var _authFormValidation = require('./authFormValidation');

var _authFormValidation2 = _interopRequireDefault(_authFormValidation);

var _formComponents = require('components/formComponents');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

var _auth2 = require('helpers/auth');

var _responseCodes = require('helpers/responseCodes');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./AuthForm.scss');

var LoginForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    loginData: state.auth.loginData
  };
}, (0, _extends3.default)({}, authActions), null, { withRef: true }), _dec2 = (0, _reduxForm.reduxForm)({
  form: 'LoginForm',
  propNamespace: 'loginForm',
  validate: _authFormValidation2.default
}), _dec3 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = _dec3(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(LoginForm, _Component);

  function LoginForm() {
    var _ref;

    (0, _classCallCheck3.default)(this, LoginForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = LoginForm.__proto__ || (0, _getPrototypeOf2.default)(LoginForm)).call.apply(_ref, [this].concat(args)));

    _this.state = {};
    return _this;
  }

  (0, _createClass3.default)(LoginForm, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var setLoginFormState = this.props.setLoginFormState;

      setLoginFormState(_auth2.loginFormStates.login);
    }
  }, {
    key: 'submit',
    value: function submit(formData) {
      var _this2 = this;

      var _props = this.props,
          login = _props.login,
          loginData = _props.loginData;
      var password = formData.password;

      var email = loginData.email || loginData.userEmail || formData.email;
      // catch requires for properly update form state
      return login(email, password).promise.then(function (resp) {
        if (resp.code === _responseCodes.loginCodes.reset) {
          _this2.toggleForm(_auth2.loginFormStates.reset);
        }
        if (resp.code === _responseCodes.loginCodes.unlock) {
          _this2.toggleForm(_auth2.loginFormStates.unlock);
        }
      }).catch(function (err) {
        return err;
      });
    }
  }, {
    key: 'toggleForm',
    value: function toggleForm(formState) {
      this.props.setLoginFormState(formState);
      this.setState({ formState: formState });
    }
  }, {
    key: 'showLoginForm',
    value: function showLoginForm() {
      this.toggleForm(_auth2.loginFormStates.login);
    }
  }, {
    key: 'showForgotForm',
    value: function showForgotForm() {
      this.toggleForm(_auth2.loginFormStates.forgot);
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$loginForm = _props2.loginForm,
          submitting = _props2$loginForm.submitting,
          handleSubmit = _props2$loginForm.handleSubmit,
          invalid = _props2$loginForm.invalid,
          t = _props2.t,
          className = _props2.className,
          loginData = _props2.loginData,
          showTerms = _props2.showTerms;
      var _state = this.state,
          isMounted = _state.isMounted,
          formState = _state.formState;

      var email = loginData.email || loginData.userEmail;
      var isShowForgotForm = [_auth2.loginFormStates.forgot, _auth2.loginFormStates.reset, _auth2.loginFormStates.unlock].includes(formState);

      if (isShowForgotForm) {
        return _react2.default.createElement(_components.ForgotPasswordForm, {
          className: className,
          termsHintClassName: styles.forgotTerms,
          showCancel: true,
          onCancel: this.showLoginForm
        });
      }

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'form',
          { className: 'form-horizontal ' + className, onSubmit: handleSubmit(this.submit) },
          email ? _react2.default.createElement(_components.AuthEmailString, { email: email }) : _react2.default.createElement(_reduxForm.Field, { name: 'email', type: 'email', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Email'), autoFocus: true }),
          _react2.default.createElement(_reduxForm.Field, { name: 'password', type: 'password', component: _formComponents.formSimpleTextInput, hideLabel: true, placeholder: t('Password') }),
          _react2.default.createElement(
            'div',
            { className: styles.buttons },
            _react2.default.createElement(
              'button',
              { type: 'submit', className: 'btn btn-primary pull-right margin-vert-10 pos-rel', disabled: isMounted && (submitting || invalid) },
              t('Sign in'),
              submitting && _react2.default.createElement(_components.Loader, { mask: true })
            ),
            _react2.default.createElement(
              'button',
              { type: 'button', className: 'btn btn-link lower margin-vert-10', onClick: this.showForgotForm },
              t('Forgot your password'),
              '?'
            )
          )
        ),
        showTerms && _react2.default.createElement(_components.TermsAgreeLink, { className: styles.loginTerms, buttonName: t('Sign in') })
      );
    }
  }]);
  return LoginForm;
}(_ClientSideComponent2.default), _class3.propTypes = {
  className: _propTypes2.default.string,
  login: _propTypes2.default.func,
  loginData: _propTypes2.default.object,
  loginForm: _propTypes2.default.object,
  setLoginFormState: _propTypes2.default.func,
  showTerms: _propTypes2.default.bool,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'submit', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'submit'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'toggleForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'toggleForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showLoginForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showLoginForm'), _class2.prototype), _applyDecoratedDescriptor(_class2.prototype, 'showForgotForm', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'showForgotForm'), _class2.prototype)), _class2)) || _class) || _class) || _class);
exports.default = LoginForm;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AuthForms/LoginForm.js
// module id = 1955
// module chunks = 1